module.exports = __webpack_public_path__ + "assets/images/profiles/2020-2.jpg?v=d1c1f1a5";